import React, { Component } from 'react';
import Helmet from 'react-helmet';
import RealfireFeatures from './features/RealfireFeatures';
import { Container, Row, Col } from 'reactstrap';
import Link from 'gatsby-link';
import ActionLink from '../../../components/actionlink/ActionLink';

import "../../../layouts/bootstrap.css";
import './index.scss'
var version = '5.3.2';
var versionWin32 = '5.0.7';

var downloadUrl = `${process.env.GATSBY_REALFORCE_SERVER_URL}/api/v2.0/download?version=${version}`
var downloadWin32Url = `${process.env.GATSBY_REALFORCE_SERVER_URL}/api/v2.0/download?version=${versionWin32}`
var win64DownloadUrl = `${downloadUrl}&file=realfire-${version}-windows.x86_64.zip`;
var win32DownloadUrl = `${downloadWin32Url}&file=realfire-${versionWin32}-windows.x86_32.zip`;
var linuxDownloadUrl = `${downloadUrl}&file=realfire-${version}-linux.x86_64.tar.gz`;
var macDownloadUrl = `${downloadUrl}&file=realfire-${version}.dmg`;

class RealfirePage extends Component {
    render() {
        return (
            <div className='realforce-container'>
                <Helmet title={`Datasert - Realfire`} />

                <div className="main">
                    <Container>
                        <Row>
                            <div className="alert alert-warning" role="alert">
                            Realfire is NOT impacted by to log4j2 vulnerability (CVE-2021-44228). Read more about it <Link to='/products/realfire/log4j2'>here</Link>.
                            </div>
                            <br/>
                            <br/>
                        </Row>
                        <Row>

                            <Col className='main-left'>
                                <h2>Realfire</h2>
                                <h3>Experience the Next Level of Salesforce Data Management</h3>
                                <p>Current Version: {version}</p>
                                <p>Read <Link to='/products/realfire/docs/'>Docs</Link> or <Link to='/products/realfire/release-notes'>Release Notes</Link> or <Link to='/products/realfire/faq'>FAQ</Link></p>
                                <p>
                                    By downloading, you are agreeing to Realfire <a href="/resources/eula" target="_blank">EULA</a> and <a href="/resources/privacy" target="_blank">Privacy Policy</a>
                                </p>
                                <ActionLink className='button-download-product btn-icon-windows' href={win64DownloadUrl}>Windows 64 bit</ActionLink>
                                <ActionLink className='button-download-product btn-icon-apple' href={macDownloadUrl}>Mac 64 bit</ActionLink>
                                <ActionLink className='button-download-product btn-icon-linux' href={linuxDownloadUrl}>Linux 64 bit</ActionLink>
                                {/* <br/>
                                <p>
                                    Windows 32 bit is not supported in latest version of Realfire. Last version supported is 5.0.7
                                </p>
                                <ActionLink className='button-download-product btn-icon-windows' href={win32DownloadUrl}>Windows 32 bit [5.0.7]</ActionLink> */}
                            </Col>
                            <Col><img className='banner-image' src={require('./features/query-results-edit/edit-records.png')} /></Col>
                        </Row>
                    </Container>
                </div>

                <div className="features">
                    <h2 className='title'>Discover the Features</h2>
                    <a name="features"></a>
                    <RealfireFeatures />
                </div>
            </div>
        );
    }
}

export default RealfirePage;


// WEBPACK FOOTER //
// ./src/pages/products/realfire/index.jsx